export const faqs = [
  {
    q: '爆料官网的内容主要覆盖哪些频道？',
    a: '目前设置娱乐爆料、科技内幕、财经揭密、社会民生、消费维权、职场内幕、汽车真相、房产观察、教育真相、健康真相共十个频道。每个频道都有独立的更新节奏与选题标准，你可以只订阅自己关注的几个领域。',
  },
  {
    q: '如何快速找到自己感兴趣的爆料领域？',
    a: '最直接的方式是使用顶部导航栏：进入“频道列表”可以按领域浏览全部内容；进入“专题分类”则能按主题（如行业黑幕、品牌翻车、维权案例）横向聚合。首页也提供了频道概览与热门推荐，适合第一次访问时先逛一圈。',
  },
  {
    q: '内容板块之间有什么区别？',
    a: '独家爆料以短平快的线索为主，深度调查篇幅更长、核实更充分，热点追踪按时间线持续更新，网友投稿保留当事人视角，辟谣专区专注核实与澄清，维权指南则把案例整理成可操作的步骤。你可以按阅读目的选择对应板块。',
  },
  {
    q: '我可以向网站投稿自己的经历吗？',
    a: '可以。在“关于我们”页面底部有投稿与联系表单，填写事情经过、涉及方与你能提供的材料说明即可。建议尽可能描述清楚时间、地点与关键对话，这会明显提高线索被采用的概率。',
  },
  {
    q: '投稿之后会收到回复吗？',
    a: '编辑部会逐一阅读投稿内容。如果线索进入核实流程，我们可能会通过你留下的联系方式进一步确认细节；如果暂时不适合发布，通常不会单独通知，但相关内容会保留作为后续选题参考。',
  },
  {
    q: '网站如何保证内容的可信度？',
    a: '所有内容遵循同一套内容原则：以公开可查的信息为基础，涉及具体指控时至少有两个独立信源，并对当事方给出的回应进行同等篇幅的呈现。对于无法核实的说法，会明确标注“待核实”或归入辟谣专区。',
  },
  {
    q: '浏览网站需要付费或注册吗？',
    a: '浏览全部频道、专题与文章都不需要注册，也不收取任何费用。我们希望通过清晰的栏目结构与导航设计，让每个人都能低成本地获取信息。',
  },
  {
    q: '发现文章内容有误，应该如何反馈？',
    a: '可以通过“关于我们”页面的联系表单提交更正说明，注明文章标题与你认为有误的段落。核实后我们会在原文中更新修订说明，保留修改记录，确保信息可追溯。',
  },
];